<template>
  <div class="hubspot-form u-pad-x-3of12 u-pad-x-1of12--sm u-pad-y-xl u-pad-y-md--sm">
    <div class="u-pad-lg u-pad-x-md--sm u-bg-white u-radius">
      <div :id="'form_' + data.formId + '-' + timestamp" v-once />
    </div>
  </div>
</template>

<script>
import { hubspot } from '@/utils/Hubspot'

export default {
  props: {
    data: {
      type: Object,
      required: true
    },
  },

  data () {
    return {
      timestamp: Date.now()
    }
  },

  mounted() {
    hubspot.promise.then(() => {
      hubspot.createForm(
        `hbspt.forms.create({
          region: "${this.data.region}",
          portalId: "${this.data.portalId}",
          formId: "${this.data.formId}",
          target: "#form_${this.data.formId}-${this.timestamp}"
        })`)
    })
  }

}
</script>

<style lang="stylus">
</style>